const CONTACTS_PAGE_SIZE = 15;

export default CONTACTS_PAGE_SIZE;
